import { faFilter, faXmark } from "@fortawesome/pro-solid-svg-icons"
import CloseIcon from "@mui/icons-material/Close"
import { Alert, Box, Button, Grid, Snackbar } from "@mui/material"
import { AppContext } from "components/AppContextProvider"
import React, { useContext, useEffect } from "react"
import { MapContext } from "../MapContextProvider"
import DateRangePickerTimeline from "../Timeline/DateRangePicker"
import {
  StyledBlueGrid,
  StyledDateGrid,
  StyledDeviceListGrid,
  StyledFontAwesomeIcon,
  StyledGrid,
  StyledGridButton,
  StyledIconButton,
  StyledToggleFontAwesomeIcon
} from "./Header.styled"
import { useTranslation } from "react-i18next"
import { StyledFontAwesomeIconForButton } from "shared/styled/General"

const ButtonAppBar = () => {
  const { t } = useTranslation()
  const { activeMarker, resetHistory, historyPositionsData, loadingMarkers } = useContext(MapContext)
  const appContext = useContext(AppContext)
  const [open, setOpen] = React.useState(false)
  const handleClose = () => {
    setOpen(false)
  }

  useEffect(() => {
    setOpen(false)
    if (activeMarker !== null && historyPositionsData.status === 2 && historyPositionsData.data.length <= 0) {
      setOpen(true)
    }
  }, [historyPositionsData, activeMarker, loadingMarkers])

  return (
    <>
      <Snackbar anchorOrigin={{ vertical: "top", horizontal: "center" }} open={open} autoHideDuration={3000}>
        <Alert severity="info" elevation={6} variant="filled">
          {t("map.no_positions_found_for_the_selected_range", "No positions found for the selected range")}
          <StyledIconButton aria-label="close" color="inherit" onClick={handleClose}>
            <CloseIcon />
          </StyledIconButton>
        </Alert>
      </Snackbar>
      <StyledGrid container direction="row" alignItems="center">
        {activeMarker ? (
          <>
            <StyledDateGrid item>
              <DateRangePickerTimeline />
            </StyledDateGrid>
            <Grid item>
              <StyledBlueGrid container direction="row" alignItems="center" gap={1}>
                <Grid item>{t("global.selected_vehicle", "Selected vehicle")}</Grid>
                <Grid item marginRight={1}>
                  <Box sx={{ fontWeight: 600 }}>{activeMarker?.label}</Box>
                </Grid>
                <Grid item marginRight={1}>
                  <StyledFontAwesomeIcon icon={faXmark} onClick={resetHistory} size="1x" />
                </Grid>
              </StyledBlueGrid>
            </Grid>
          </>
        ) : null}


      </StyledGrid>
      <StyledGridButton container direction="row" alignItems="center">
        <StyledDeviceListGrid item>
          <Button onClick={() => appContext.toggleSideBar(true)} color="primary" variant="contained">
            {t("map.vehicle_list", "Vehicle list")}
            <StyledFontAwesomeIconForButton icon={faFilter} />
          </Button>
        </StyledDeviceListGrid>
      </StyledGridButton>
    </>
  )
}
export default ButtonAppBar
